<!--itemsUserQuestions (4)-->
<!--loadData (7)-->
<!--/user_questions/ (6)-->
<template>
  <v-container>
    <v-breadcrumbs :items="breadCrumbsItems">
      <template v-slot:prepend>
        <v-icon icon="mdi mdi-format-list-bulleted" size="small"></v-icon>
      </template>
    </v-breadcrumbs>
    <v-card title="Preguntas de usuarios" class="elevation-3">
      <template v-slot:text>
        <v-text-field
          v-model="search"
          label="Buscar"
          prepend-inner-icon="mdi-magnify"
          variant="outlined"
          hide-details
          single-line
        ></v-text-field>
      </template>
      <v-data-table
        :headers="headers"
        :items="itemsUserQuestionsTemp"
        :loading="loading"
        :search="search"
        @update:options="loadData"
      >
        <template v-slot:top>
          <v-toolbar flat>
            <v-toolbar-title>Registros</v-toolbar-title>
            <v-divider class="mx-4" inset vertical></v-divider>
            <v-dialog v-model="dialogForm" max-width="90%">
              <template v-slot:activator="{ props }">
                <v-btn
                  class="mb-2"
                  color="black"
                  dark
                  v-bind="props"
                  append-icon="mdi-plus-circle"
                  size="small"
                >
                  Agregar
                </v-btn>
              </template>
              <v-card>
                <v-card-title>
                  <span class="text-h5">{{ dialogFormTitle }}</span>
                </v-card-title>
                <v-card-text>
                  <v-container>
                    <v-row>
                      <v-col cols="12" md="6" sm="6" hidden>
                        <v-text-field
                          v-model="selectedItem.id"
                          label="id"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" md="6" sm="6">
                        <v-text-field
                          v-model="selectedItem.comment_evaluator"
                          label="comment_evaluator"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" md="6" sm="6">
                        <v-text-field
                          v-model="selectedItem.comment_evaluated_instance"
                          label="comment_evaluated_instance"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" md="6" sm="6">
                        <v-select
                          v-model="selectedItem.user_id"
                          :items="selectUserId"
                          label="user_id"
                          outlined
                        ></v-select>
                      </v-col>
                      <v-col cols="12" md="6" sm="6">
                        <v-select
                          v-model="selectedItem.question_id"
                          :items="selectQuestionId"
                          label="question_id"
                          outlined
                        ></v-select>
                      </v-col>
                      <v-col cols="12" md="6" sm="6">
                        <v-select
                          v-model="selectedItem.boolean_status"
                          :items="selectBooleanStatus"
                          label="Estado"
                          outlined
                        ></v-select>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn
                    color="grey-darken-2"
                    variant="text"
                    @click="closeDialogForm"
                  >
                    Cancelar
                  </v-btn>
                  <v-btn
                    color="grey-darken-2"
                    variant="text"
                    @click="confirmDialogForm"
                  >
                    Guardar
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
            <v-dialog v-model="dialogDelete" max-width="90%">
              <v-card>
                <v-card-title class="text-h5"
                  >¿Estás seguro de que quieres eliminar este
                  registro?</v-card-title
                >
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn
                    color="grey-darken-2"
                    variant="text"
                    @click="closeDialogDelete"
                    >Cancelar</v-btn
                  >
                  <v-btn
                    color="grey-darken-2"
                    variant="text"
                    @click="confirmDialogDelete"
                    >Borrado logico</v-btn
                  >
                  <v-btn
                    color="red-accent-4"
                    variant="text"
                    @click="permanentlyDelete"
                    >Borrado definitivo</v-btn
                  >
                  <v-spacer></v-spacer>
                </v-card-actions>
              </v-card>
            </v-dialog>
            <v-dialog v-model="dialogView" max-width="90%">
              <v-card>
                <v-card-title class="text-h5"
                  >id: {{ selectedItem.id }}</v-card-title
                >
                <v-card-text>
                  comment_evaluator:<br />
                  {{ selectedItem.comment_evaluator }} <br /><br />
                  comment_evaluated_instance:<br />
                  {{ selectedItem.comment_evaluated_instance }} <br /><br />
                  user_id:<br />
                  {{ selectedItem.user_id }} <br /><br />
                  question_id:<br />
                  {{ selectedItem.question_id }} <br /><br />
                  boolean_status:<br />
                  {{ selectedItem.boolean_status }} <br /><br />
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn
                    color="grey-darken-2"
                    variant="text"
                    @click="closeDialogView"
                    >Cerrar</v-btn
                  >
                  <v-spacer></v-spacer>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-toolbar>
        </template>
        <template v-slot:[`item.comment_evaluator`]="{ value }">
          <v-chip
            v-if="value === 'sin revisar'"
            color="gray"
            text="sin revisar"
            class="text-uppercase"
            size="small"
            label
          ></v-chip>
          <v-chip
            v-else-if="value === 'aprobado'"
            color="green"
            text="aprobado"
            class="text-uppercase"
            size="small"
            label
          ></v-chip>
          <v-chip
            v-else
            color="orange"
            :text="value.toString()"
            class="text-uppercase"
            size="small"
            label
          ></v-chip>
        </template>
        <template v-slot:[`item.boolean_status`]="{ value }">
          <v-chip
            :color="value === 'activo' ? 'green' : 'red'"
            :text="value.toString()"
            class="text-uppercase"
            size="small"
            label
          ></v-chip>
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <div style="width: max-content">
            <v-icon class="mx-1" size="small" @click="openDialogForm(item)">
              mdi-pencil
            </v-icon>
            <v-icon class="mx-1" size="small" @click="openDialogDelete(item)">
              mdi-delete
            </v-icon>
            <v-icon class="mx-1" size="small" @click="openDialogView(item)">
              mdi-eye
            </v-icon>
          </div>
        </template>
        <template v-slot:no-data>
          Datos no disponibles
          <br />
          <v-btn
            append-icon="mdi-refresh-circle"
            variant="outlined"
            @click="loadData"
          >
            Actualizar
          </v-btn>
        </template>
      </v-data-table>
    </v-card>
  </v-container>
</template>

<script>
import { databaseLoadItems } from "@/assets/js/index.js";
import { dataBaseAddUpdateItem } from "@/assets/js/index.js";
import { dataBaseDeleteItem } from "@/assets/js/index.js";
export default {
  data() {
    return {
      itemsUserQuestions: [],
      itemsUserQuestionsTemp: [],
      itemsUsers: [],
      itemsQuestions: [],
      headers: [
        { title: "ID", key: "id" },
        { title: "Comentario del evaluador", key: "comment_evaluator" },
        {
          title: "Comentario de la instancia evaluada",
          key: "comment_evaluated_instance",
        },
        { title: "Id de usuario", key: "user_id" },
        { title: "Id de pregunta", key: "question_id" },
        { title: "Estado activo", key: "boolean_status" },
        { title: "Acciones", key: "actions", sortable: false },
      ],
      selectBooleanStatus: [
        { title: "Activo", value: 1 },
        { title: "Inactivo", value: 0 },
      ],
      selectUserId: [],
      selectQuestionId: [],
      loading: false,
      search: "",
      dialogForm: false,
      dialogDelete: false,
      dialogView: false,
      selectedItem: {},
      breadCrumbsItems: [
        {
          title: "Lista de instancias evaluadas",
          disabled: false,
          href: "/#/instancias-evaluadas",
        },
        {
          title: "Lista de CRUD's",
          disabled: false,
          href: "/#/lista-CRUDs",
        },
        {
          title: "CRUD Preguntas de Usuario",
          disabled: true,
        },
      ],
    };
  },
  mounted() {},
  computed: {
    dialogFormTitle() {
      return this.selectedItem.id === undefined
        ? "Agregar registro"
        : "Editar registro";
    },
  },
  watch: {
    dialogForm(val) {
      val || this.closeDialogForm();
    },
    dialogDelete(val) {
      val || this.closeDialogDelete();
    },
    dialogView(val) {
      val || this.closeDialogView();
    },
  },
  methods: {
    openDialogForm(item) {
      for (const itemUserQuestion of this.itemsUserQuestions) {
        if (item.id === itemUserQuestion.id) {
          this.selectedItem = structuredClone(itemUserQuestion);
          break;
        }
      }
      this.dialogForm = true;
    },

    openDialogView(item) {
      this.selectedItem = Object.assign({}, item);
      this.dialogView = true;
    },

    openDialogDelete(item) {
      for (const itemUserQuestion of this.itemsUserQuestions) {
        if (item.id === itemUserQuestion.id) {
          this.selectedItem = structuredClone(itemUserQuestion);
          break;
        }
      }
      this.dialogDelete = true;
    },

    closeDialogForm() {
      this.dialogForm = false;
      this.$nextTick(() => {
        this.selectedItem = Object.assign({});
      });
    },

    closeDialogDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.selectedItem = Object.assign({});
      });
    },

    closeDialogView() {
      this.dialogView = false;
      this.$nextTick(() => {
        this.selectedItem = Object.assign({});
      });
    },

    async confirmDialogDelete() {
      this.loading = true;
      this.selectedItem.boolean_status = 0;
      await dataBaseAddUpdateItem(
        this.$store.state.apiUrl + "user_questions/update",
        this.selectedItem
      );
      this.closeDialogDelete();
      this.loadData();
    },

    async permanentlyDelete() {
      this.loading = true;
      await dataBaseDeleteItem(
        this.selectedItem.id,
        this.$store.state.apiUrl + "user_questions/delete_physically"
      );
      this.closeDialogDelete();
      this.loadData();
    },

    async confirmDialogForm() {
      this.loading = true;
      var request =
        this.selectedItem.id === undefined
          ? this.$store.state.apiUrl + "user_questions/add"
          : this.$store.state.apiUrl + "user_questions/update";
      await dataBaseAddUpdateItem(request, this.selectedItem);
      this.closeDialogForm();
      this.loadData();
    },

    async loadData() {
      //start loading
      this.loading = true;
      //load itemsUserQuestions
      this.itemsUserQuestions = await databaseLoadItems(
        this.$store.state.apiUrl + "user_questions/select_all"
      );
      //load itemsUsers
      this.itemsUsers = await databaseLoadItems(
        this.$store.state.apiUrl + "users/select_all"
      );
      //load itemsQuestions
      this.itemsQuestions = await databaseLoadItems(
        this.$store.state.apiUrl + "questions/select_all"
      );
      // asign itemsUserQuestionsTemp
      this.itemsUserQuestionsTemp = structuredClone(this.itemsUserQuestions);
      // edit itemsUserQuestionsTemp
      for (const itemUserQuestion of this.itemsUserQuestionsTemp) {
        // itemsUserQuestionsTemp - user_id
        for (const itemUser of this.itemsUsers) {
          if (itemUserQuestion.user_id === itemUser.id) {
            itemUserQuestion.user_id = itemUser.id + ".- " + itemUser.user_name;
            break;
          }
        }
        // itemsUserQuestionsTemp - question_id
        for (const itemQuestion of this.itemsQuestions) {
          if (itemUserQuestion.question_id === itemQuestion.id) {
            itemUserQuestion.question_id =
              itemQuestion.id + ".- " + itemQuestion.question_body;
            break;
          }
        }
        // itemsUserQuestionsTemp - boolean_status
        if (itemUserQuestion.boolean_status === 1) {
          itemUserQuestion.boolean_status = "activo";
        } else if (itemUserQuestion.boolean_status === 0) {
          itemUserQuestion.boolean_status = "inactivo";
        }
      }
      // selectUserId - v-select
      this.selectUserId = structuredClone([]);
      for (const itemUser of this.itemsUsers) {
        this.selectUserId.push({
          title: itemUser.id + ".- " + itemUser.user_name,
          value: itemUser.id,
        });
      }
      // selectQuestionId - v-select
      this.selectQuestionId = structuredClone([]);
      for (const itemQuestion of this.itemsQuestions) {
        this.selectQuestionId.push({
          title:
            (itemQuestion.id + ".- " + itemQuestion.question_body).substring(
              0,
              30
            ) + "...",
          value: itemQuestion.id,
        });
      }
      //setTimeout and stop loading
      setTimeout(() => {
        this.loading = false;
      }, 500);
    },
  },
};
</script>
